import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormDataHelper, TranslateHelper } from '@app/_helpers';
import { VendorRequestService } from '@app/_services';
import { ToastrService } from 'ngx-toastr';
import { PlanDetailsComponent } from '../plan-details/plan-details.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-complete-vendor-register',
    templateUrl: './complete-vendor-register.component.html',
    styleUrls: ['./complete-vendor-register.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, PlanDetailsComponent],
})
export class CompleteVendorRegisterComponent implements OnInit {

    _id;
    plan;
    vendorRequest;
    submitting = false;

    form = this.fb.group({
        _id: [null],
        planId: [null],
        marketing : true,
        services: [null],
    });

    constructor(public translateHelper: TranslateHelper,
        protected vendorRequestService: VendorRequestService,
        private fb: UntypedFormBuilder,
        private fd: FormDataHelper,
        private route: ActivatedRoute,
        private router: Router,
        private toastr: ToastrService) { }

    ngOnInit(): void {
        this._id = this.route.snapshot.paramMap.get('id');
        this.vendorRequestService.getRequest(this._id).subscribe(
            (result) => {
                if (result.code != 200) {
                    this.toastr.error(result.msg, "Error");
                    //this.router.navigate(['/']);
                }
                this.plan = result.data?.plan;
                this.vendorRequest = result.data?.request;
                this.form.get('_id').setValue(this.vendorRequest._id);
                this.form.get('planId').setValue(this.plan?._id);
            }, (error) => {
                this.toastr.error(error, "Error");
                //this.router.navigate(['/'])
            }
        )
    }

    updateRegistration() {
        this.submitting = true;
        this.vendorRequestService.updateRequest(this.form.value).subscribe(
            (result) => {
                if (result.code != 200) {
                    this.toastr.error(result.msg, "Error");
                    return false;
                }
                if (!result.data.orderId) {
                    this.toastr.error("Order not ready", "Error");
                    return false;
                }
                this.router.navigate(['/checkout-s', result.data.orderId, 'vendor-registration']);
                return true;
            },
            (error) => {
                this.toastr.error(error, "Error");
                return false;
            },
            () => {
                this.submitting = false;
            }
        )
    }
}
